import { cn } from "@/lib/utils";

// ব্র্যান্ডের প্রশ্নচিহ্ন-লোগো (মূল অ্যাপের মতোই) + ওয়ার্ডমার্ক
export default function Logo({ className, size = 32 }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <img src="/mumtahin-logo-192.png" alt="" width={size} height={size} style={{ width: size, height: size }} />
      <span className="font-display text-[1.15rem] font-bold leading-none text-foreground">
        মুমতাহিন <span className="text-primary">গ্যালারি</span>
      </span>
    </span>
  );
}
